import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import ClIcon from '../ClIcon';
import ClIconButton from '../ClIconButton';
import { getRange, setRange } from 'selection-ranges';
import { applyClasses } from '../../lib';
let ClChip = class ClChip extends Vue {
    /**
     * Handle Input
     * in order to retain the cursor position on each sentence update
     * we need to get the range and reset it to what it was before the update
     */
    handleInput(event) {
        this.$emit('input', event.target.innerHTML);
        const node = this.$refs.label;
        const range = getRange(node);
        if (range) {
            // when changing sentence data
            // we inadvertently reset the cursor position to 0
            // this will set the cursor position to
            // what it was before we rehydrate the sentence
            this.$nextTick(() => {
                setRange(node, range);
            });
        }
    }
    render(h) {
        const { delete: onDelete, ...listeners } = this.$listeners;
        const hasDelete = this.deletable && Boolean(onDelete);
        const labelData = {};
        const clickable = this.clickable || Boolean(this.$listeners.click);
        if (this.contenteditable) {
            labelData.attrs = {
                contenteditable: this.contenteditable
                    ? String(this.contenteditable)
                    : undefined,
                placeholder: this.placeholder
            };
            labelData.ref = 'label';
            labelData.on = {
                blur: (event) => {
                    this.$emit('blur', event);
                },
                focus: (event) => {
                    this.$emit('focus', event);
                },
                input: this.handleInput,
                keydown: (event) => {
                    this.$emit('keydown', event);
                },
                keyup: (event) => {
                    this.$emit('keyup', event);
                }
            };
            labelData.domProps = {
                innerHTML: this.value
            };
        }
        const Component = this.component;
        return (<Component {...{
            on: listeners,
            attrs: {
                role: clickable && 'button'
            }
        }} class={applyClasses({
            'cl-chip': true,
            'cl-chip--disabled': this.disabled,
            'cl-chip--editable': this.contenteditable,
            'cl-chip__root': true,
            [`cl-chip--color-${this.color}`]: true,
            [`cl-chip--variant-${this.variant}`]: this.variant !== 'default',
            'cl-chip--with-content-left': Boolean(this.$slots.left),
            'cl-chip--with-content-right': Boolean(hasDelete || this.$slots.right),
            'cl-chip--clickable': clickable
        }, this.classes.root)}>
        {this.$slots.avatar || this.$slots.icon}
        {this.$slots.left}
        <span class={applyClasses({ 'cl-chip__label': true }, this.classes.label)} {...labelData}>
          {this.label}
        </span>
        {this.$slots.right}
        {hasDelete && (<span class="cl-chip__delete-icon-container">
            {this.$slots['delete-icon'] || (<ClIcon class="cl-chip__delete-icon" {...{ on: { click: onDelete } }} focusable="false" role="presentation">
                cancel
              </ClIcon>)}
          </span>)}
      </Component>);
    }
};
tslib_1.__decorate([
    Prop({
        default: () => ({
            root: '',
            label: ''
        }),
        type: Object
    })
], ClChip.prototype, "classes", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean
    })
], ClChip.prototype, "clickable", void 0);
tslib_1.__decorate([
    Prop({
        default: 'default',
        type: String,
        validator: x => ['default', 'primary', 'secondary'].includes(x)
    })
], ClChip.prototype, "color", void 0);
tslib_1.__decorate([
    Prop({
        default: 'div',
        type: String
    })
], ClChip.prototype, "component", void 0);
tslib_1.__decorate([
    Prop({
        default: false,
        type: Boolean
    })
], ClChip.prototype, "contenteditable", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: false
    })
], ClChip.prototype, "disabled", void 0);
tslib_1.__decorate([
    Prop({
        default: '',
        type: String
    })
], ClChip.prototype, "label", void 0);
tslib_1.__decorate([
    Prop(String)
], ClChip.prototype, "placeholder", void 0);
tslib_1.__decorate([
    Prop({
        default: '',
        type: [String, Number]
    })
], ClChip.prototype, "value", void 0);
tslib_1.__decorate([
    Prop({
        default: 'default',
        type: String,
        validator: x => ['outlined', 'default'].includes(x)
    })
], ClChip.prototype, "variant", void 0);
tslib_1.__decorate([
    Prop(Boolean)
], ClChip.prototype, "deletable", void 0);
ClChip = tslib_1.__decorate([
    Component({
        components: { ClIcon, ClIconButton }
    })
], ClChip);
export default ClChip;
